module.exports = __webpack_public_path__ + "img/1979-850x510-stonehenge.1529d346.jpg";